import React from 'react';
import ReactDOM from 'react-dom/client';

import './containers/SiteSearchInput';
import './containers/SiteSearch';
import './containers/ExhibitorsCatalog';
import './containers/ArtworksCatalog';
import './containers/PressImagesOverview';
import { FairInteractiveMap } from './containers/FairInteractiveMap';
import { FairStaticMap } from './containers/FairStaticMap';
import './suppressNextReactWarning';

document.addEventListener('DOMContentLoaded', () => {
  const fairInteractiveMaps = document.getElementsByClassName('fair-interactive-map-container');
  if (fairInteractiveMaps && fairInteractiveMaps.length > 0) {
    for (let i = 0; i < fairInteractiveMaps.length; i += 1) {
      const fairInteractiveMap = fairInteractiveMaps[i];
      if (fairInteractiveMap) {
        const svg = fairInteractiveMap ? fairInteractiveMap.querySelector('svg') : null;
        if (svg) {
          const settings = fairInteractiveMap?.dataset || null;
          if (settings) {
            ReactDOM.createRoot(fairInteractiveMap).render(
              <React.StrictMode>
                <FairInteractiveMap
                  exhibitorsPublicUrl={settings.exhibitorsPublicUrl}
                  exhibitorsIndexName={settings.exhibitorsIndexName}
                  artworksPublicUrl={settings.artworksPublicUrl}
                  artworksIndexName={settings.artworksIndexName}
                  jwt={settings.jwt}
                  refreshUrl={settings.refreshUrl}
                  fairTitle={settings.fairTitle}
                  fairId={settings.fairId}
                  showArtworks={!!settings.showArtworks}
                  pois={JSON.parse(settings.pois)}
                  mapBgColor={settings.mapBgColor}
                  hideHome={!!settings.hideHome}
                  floors={JSON.parse(settings.floors)}
                >
                  {svg}
                </FairInteractiveMap>
              </React.StrictMode>,
            );
          }
        }
      }
    }
  }

  const fairStaticMaps = document.getElementsByClassName('fair-static-map-container');
  if (fairStaticMaps && fairStaticMaps.length > 0) {
    for (let i = 0; i < fairStaticMaps.length; i += 1) {
      const fairStaticMap = fairStaticMaps[i];
      if (fairStaticMap) {
        const svg = fairStaticMap ? fairStaticMap.querySelector('svg') : null;
        if (svg) {
          const stand = fairStaticMap.getAttribute('data-stand');
          const pois = JSON.parse(fairStaticMap.getAttribute('data-pois'));
          const mapBgColor = fairStaticMap.getAttribute('data-map-bg-color');
          const onStandClickUrl = fairStaticMap.getAttribute('data-on-stand-click-url');

          ReactDOM.createRoot(fairStaticMap).render(
            <React.StrictMode>
              <FairStaticMap
                stand={stand}
                pois={pois}
                mapBgColor={mapBgColor}
                onStandClickUrl={onStandClickUrl}
              >
                {svg}
              </FairStaticMap>
            </React.StrictMode>,
          );
        }
      }
    }
  }
});
